<template>
  <div class="page" v-loading="loading">
    <div class="filter-wrapper">
      <el-form
        ref="form"
        inline
        :model="form"
        @submit.native.prevent="handleSubmit('form')"
      >
        <el-form-item prop="begin_date_and_end_date" :rules="{ required: true, message: '请选择时间区间' }">
          <el-date-picker
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            v-model="form.begin_date_and_end_date"
          />
        </el-form-item>
        <el-form-item prop="userIds" :rules="{ required: true, message: '请选择用户' }">
          <el-select
            v-model="form.userIds"
            multiple
            filterable
            remote
            placeholder="填写用户名称/编号搜索"
            :remote-method="remoteMethod"
            :loading="selectLoading">
            <el-option
              v-for="user in search"
              :key="user.id"
              :label="user.name_with_id"
              :value="user.name_with_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" native-type="submit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="chart-area">
      <div class="chart-wrapper" v-for="(options, index) in optionsList" :key="index">
        <c-echarts v-if="options" :options="options" />
      </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import _ from 'lodash'
import moment from 'moment';

@Component
export default class UserInvitingData extends Vue {

  optionsList = [];
  loading = false;
  selectLoading = false;
  search = [];
  choosedSearch = [];

  form = {
    // 默认选中一周
    begin_date_and_end_date: [moment().add('days', -6), moment()].map((ele) => ele.format('YYYY-MM-DD')),
    userIds: []
  };

  pickerOptions = {
    disabledDate(current) {
      return moment(new Date()).diff(moment(current)) < 0 || moment().add(-1, 'y').diff(moment(current)) > 0;
    }
  }

  async remoteMethod(query) {
    if (query !== '') {
      this.selectLoading = true;
      const { data } = await this.$request.get(`/users?per_page=100&key_word_in=${query}`);
      this.selectLoading = false;
      this.search = data;
    }
  }

  async handleSubmit(formName) {
    await this.$refs[formName].validate();
    this.loading = true;
    this.fetchData().finally(() => this.loading = false);
  }

  async fetchData() {
    const data = await this.$request.get('/statistics/analyses', {
      params: {
        ...this.form, user_ids: this.form.userIds.map(ele => +(/ID([0-9]+)$/.exec(ele)[1]))
      }
    })
    this.optionsList = _.map(data, (value, key) => {
      const title = `${key}:  ${value.period_data} 元`;
      const datas = value.data_source;

      return {
        title: {
          text: title,
          textStyle: {
            fontStyle: 14
          }
        },
        xAxis: {
          type: 'category',
          data: _.keys(datas),
          axisLabel: {
            fontWeight: 800
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            fontWeight: 800
          }
        },
        series: [{
          data: _.values(datas),
          type: 'line',
          smooth: true,
          areaStyle: { opacity: 0.5 }
        }]
      }
    })
  }
}
</script>


<style lang="scss" scoped>

.filter-wrapper {
  margin-top: 1em;

  /deep/ .item-16 {
    display: block !important;
  }

  &:after {
    content: '';
    clear: both;
    display: table;
  }
}

.chart-area {
  margin-top: 3em;

  .chart-wrapper {
    float: left;

    .echarts {
      width: 500px;
      height: 350px;
    }
  }
}

.el-select {
  width: 350px;
}

</style>

<style lang="scss">
  .user-invinting-data-meta-info {
    span {
      font-weight: 800;
    }

    p {
      margin: 0.2em 0;
    }
  }

  .user-invinting-data-meta-info-icon {
    margin-left: -10px;
    margin-right: 10px;
    cursor: pointer;
  }
</style>
